<template>
    <v-container>
        <v-row>
            <v-col
                class="mt-4 pb-4 pl-0 add-user-header"
                cols="12"
            >
                <div class="header-content">
                    <div>
                        <v-btn
                            icon
                            class="btn-back"
                            @click="cancel"
                        >
                            <v-icon class="material-icons-outlined">
                                chevron_left
                            </v-icon>
                        </v-btn>
                        <span v-if="isEditUser && getEditUser">{{ getEditUser.name }}</span>
                        <span v-else>Add User</span>
                    </div>
                    <div
                        v-if="isEditUser && getEditUser"
                        class="d-flex"
                    >
                        <div class="user-created-info">
                            <span>Created: <b>{{ formateDate(getEditUser.created) }} By {{ getEditUser.created_by }}</b> ({{ fromNow(getEditUser.created) }})</span>
                            <span class="ml-3">Last Updated: <b>{{ formateDate(getEditUser.updated) }} By {{ getEditUser.updated_by }}</b> ({{ fromNow(getEditUser.updated) }})</span>
                            <div>
                                <span>Last on: <b>{{ formateDate(getEditUser.last_on) }}</b> ({{ fromNow(getEditUser.last_on) }})</span>
                            </div>
                        </div>
                        <v-btn
                            style="text-transform: none !important"
                            class="text-subtitle-2 ml-4"
                            color="error"
                            outlined
                            :disabled="!hasDeletePermission"
                            @click="deleteUserDialog = true"
                        >
                            <v-icon>mdi-delete-outline</v-icon>
                            Delete
                        </v-btn>
                    </div>
                </div>
            </v-col>
            <v-col
                cols="2"
                class="pl-0 pt-0 user-stepper"
            >
                <v-stepper
                    v-model="stepper"
                    flat
                    vertical
                >
                    <v-stepper-step
                        step="1"
                        class="pl-1"
                        :complete="stepper > 1 && !isEditUser"
                    >
                        User Information
                    </v-stepper-step>
                    <v-stepper-content
                        step="1"
                        class="ml-4"
                    />

                    <v-stepper-step
                        step="2"
                        class="pl-1"
                        :complete="stepper > 2 && !isEditUser"
                    >
                        Email Settings
                    </v-stepper-step>
                    <v-stepper-content
                        step="2"
                        class="ml-4"
                    />

                    <v-stepper-step
                        step="3"
                        class="pl-1"
                        :complete="stepper > 3 && !isEditUser"
                    >
                        Alert Preferences
                    </v-stepper-step>
                    <v-stepper-content
                        step="3"
                        class="ml-4"
                    />

                    <v-stepper-step
                        step="4"
                        class="pl-1"
                        :complete="stepper > 4 && !isEditUser"
                    >
                        Permissions
                    </v-stepper-step>
                    <v-stepper-content
                        step="4"
                        class="ml-4"
                    />
                    <div v-if="isLocator">
                        <v-stepper-step                           
                            step="5"
                            class="pl-1"
                            :complete="stepper > 5 && !isEditUser"
                        >
                            Auto-Assign Hold
                        </v-stepper-step>
                        <v-stepper-content                            
                            step="5"
                            class="ml-4"
                        />
                        <v-stepper-step
                            step="6"
                            class="pl-1"
                        >
                            Vacation
                        </v-stepper-step>
                        <v-stepper-content
                            step="6"
                            class="ml-4"
                        />
                    </div>
                </v-stepper>
            </v-col>
            <v-col
                cols="10"
                class="form-area"
            >
                <v-form v-model="userForm">
                    <UserInformation
                        v-if="stepper===1"
                        ref="userInformation"
                    />
                    <EmailSettings
                        v-if="stepper===2"
                        ref="emailSetting"
                    />
                    <AlertPreferences
                        v-if="stepper===3"
                        ref="alertPreferences"
                    />
                    <Permissions 
                        v-if="stepper===4"
                        ref="userPermissions"
                        @start-loader="startLoader"
                        @stop-loader="stopLoader"
                    />
                    <AutoAssignHold 
                        v-if="stepper===5"
                        ref="autoAssignHold"                        
                    />
                    <Vacation 
                        v-if="stepper===6"
                        ref="vacation"                        
                    />
                    <div class="btn-containner">
                        <div class="btn-group ml-3">
                            <v-btn
                                v-show="stepper!==1"
                                style="text-transform: none !important; background: #fff; color: #1976D2;"
                                elevation="0"
                                @click="previousStage"
                            >
                                Back
                            </v-btn>
                            <v-btn
                                style="text-transform: none !important"
                                class="text-subtitle-2 ml-4"
                                outlined
                                @click="cancel"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                v-if="!isLocator"
                                v-show="stepper!==4"
                                class="ml-3 action-btn text-subtitle-2"
                                depressed
                                color="primary"
                                :disabled="!userForm"
                                @click="nextStage"
                            >
                                Next
                            </v-btn>
                            <v-btn
                                v-else
                                v-show="stepper!==6"
                                class="ml-3 action-btn text-subtitle-2"
                                depressed
                                color="primary"
                                :disabled="!userForm"
                                @click="nextStage"
                            >
                                Next
                            </v-btn>                                                   
                        </div>
                        <v-btn
                            v-show="stepper >= 4 && stepper !== 6 && !isEditUser"
                            class="ml-3 action-btn text-subtitle-2"
                            depressed
                            color="primary"
                            @click="saveUser()"
                        >
                            Finish
                        </v-btn>
                       
                        <v-btn
                            v-show="stepper === 6 && !isEditUser" 
                            class="ml-3 action-btn text-subtitle-2"
                            depressed
                            color="primary"
                            @click="saveUser()"
                        >
                            Finish
                        </v-btn>      
                        <v-btn
                            v-show="stepper < 6 && isEditUser"
                            style="text-transform: none !important"
                            class="text-subtitle-2 mr-4"
                            outlined
                            :disabled="!hasEditPermission "
                            @click="editUser"
                        >
                            Update and Exit
                        </v-btn>
                        <v-btn
                            v-show="stepper === 6 && isEditUser"
                            class="ml-3 action-btn text-subtitle-2"
                            depressed
                            color="primary"
                            :disabled="!hasEditPermission "
                            @click="editUser"
                        >
                            Update and Exit
                        </v-btn>
                    </div>
                </v-form>
            </v-col>
        </v-row>
        <v-dialog
            v-model="deleteUserDialog"
            hide-overlay
            width="500"
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2">
                    <span>Delete</span>
                </v-card-title>
                <v-divider />
                <v-card-text class="my-4">
                    Are you sure you want to delete <span v-if="getEditUser">"{{ getEditUser.name }}"</span> form the user list? This process cannot be undone.
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        outlined
                        light
                        @click="deleteUserDialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        style="text-transform: none !important"
                        depressed
                        color="primary"
                        @click="deleteUser"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>   
        <div
            v-if="showLoader"
            class="loader_containner"
        >
            <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
            />
        </div>
    </v-container>
</template>
<script>
import moment from 'moment';
import { hasPermission } from '../../../utils/permissions';
import webtmsBackend from '@/services/webtmsBackend';
import UserInformation from './UserInformation';
import EmailSettings from './EmailSettings';
import AlertPreferences from './AlertPreferences';
import Permissions from './Permissions';
import AutoAssignHold from './Locators/AutoAssignHold.vue';
import Vacation from './Locators/Vacation.vue';

export default {
    name: 'Users',
    components: {
        UserInformation,
        EmailSettings,
        AlertPreferences,
        Permissions,
        AutoAssignHold,
        Vacation
    },
    data: () => ({
        deleteUserDialog: false,
        isEditUser: false,
        showLoader: false,
        userForm: false,
        showAddUser: false,
        stepper: 1
    }),
    computed: {
        getEditUser() {
            return this.$store.getters.editUser;
        },
        hasEditPermission() {
            return hasPermission('USER_EDIT');
        },
        hasDeletePermission() {
            return hasPermission('USER_DELETE');
        },
        isLocator() {
            return this.getEditUser?.ingroup === 'Locator' ? true : false;
        }
    },
    async created() {
        if(this.$route.query.id) {
            this.startLoader();
            let result = await webtmsBackend.getUser(this.$route.query.id);
            this.stopLoader();
            if(result.err) {
                this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                this.$store.commit('SET_EDIT_USER', null);
                this.$router.push('users');
            } else {
                this.$store.commit('SET_EDIT_USER', { ...result });
                if(this.$refs.userInformation) {
                    this.$refs.userInformation.setFormData();
                }                
                if(this.$refs.emailSetting) {                    
                    this.$refs.emailSetting.setFormData();
                }
                if(this.$refs.alertPreferences) {
                    this.$refs.alertPreferences.setFormData();
                }
                if(this.$refs.userPermissions) {
                    this.$refs.userPermissions.setFormData();
                }
            }
            this.isEditUser = true;
        } else {
            this.$store.commit('SET_EDIT_USER', null);
        }
    },
    methods: {
        nextStage() {
            if(this.stepper === 1) {
                this.$refs.userInformation.saveUserInformation();
            } if(this.stepper === 2) {
                this.$refs.emailSetting.saveEmailSetting();
            } if(this.stepper === 3) {
                this.$refs.alertPreferences.updateAlertSettings();
            } if(this.stepper === 4) {
                this.$refs.userPermissions.savePermission();
            } if(this.stepper === 5) {
                this.$refs.autoAssignHold.saveAutoAssignHold();
            }
            this.stepper += 1;
        },
        previousStage() {
            if(this.stepper === 2) {
                this.$refs.emailSetting.saveEmailSetting();
            } if(this.stepper === 3) {
                this.$refs.alertPreferences.updateAlertSettings();
            } if(this.stepper === 4) {
                this.$refs.userPermissions.savePermission();
            } if(this.stepper === 5) {
                this.$refs.autoAssignHold.saveAutoAssignHold();
            } if(this.stepper === 6) {
                this.$refs.vacation.saveVacation();
            }
            this.stepper -= 1;
        },
        saveUser() {
            if(this.stepper === 4) {
                this.$refs.userPermissions.saveUser();
            } if(this.stepper === 5) {
                this.$refs.autoAssignHold.saveUser();
            } if(this.stepper === 6) {
                this.$refs.vacation.saveUser();
            }
        },
        editUser() {
            if(this.stepper === 1) {
                this.$refs.userInformation.editUser();
            } if(this.stepper === 2) {
                this.$refs.emailSetting.editUser();
            } if(this.stepper === 3) {
                this.$refs.alertPreferences.editUser();
            } if(this.stepper === 4) {
                this.$refs.userPermissions.editUser();
            } if(this.stepper === 5) {
                this.$refs.autoAssignHold.editUser();
            } if(this.stepper === 6) {
                this.$refs.vacation.editUser();
            }
        },
        cancel() {
            this.$store.commit('SET_EDIT_USER', null);
            this.$router.push('users');
        },
        formateDate(date) {
            return moment(date).format('MM/DD/YYYY');
        },
        fromNow(date) {
            return moment(date).fromNow();
        },
        async deleteUser() {
            try {
                let result = await webtmsBackend.updateUser({...this.getEditUser, deleted: true, passwordConfirm: '', password: ''});
                if(result.status === 'OK') {
                    this.$store.dispatch('setSnackbar', { text: `User account "${result.user.name}" deleted successfully.` });
                    this.$store.commit('SET_EDIT_USER', null);
                    this.$router.push('users');
                }
                if(result.err) {
                    this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                }
                this.deleteUserDialog = false;
            } catch(error) {
                this.$store.dispatch('setSnackbar', { color:'error', text: error });
            }
        },
        startLoader() {
            this.showLoader = true;
        },
        stopLoader() {
            this.showLoader = false;
        }
    }
};
</script>
<style>
    .loader_containner {
        background: #0000005e;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
    .user-stepper {
        font-weight: 500;
        height: 100vh;
    }
    .user-stepper .v-stepper__step__step {
        width: 24px;
        height: 24px;
    }
    .user-stepper .v-stepper__step--active {
        font-size: 14px;
        color: #35383F;
    }
    .user-stepper .v-stepper__step--inactive {
        font-weight: 400;
        font-size: 14px;
        color: #35383F;
    }
    .add-user-header {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #D5D8DE;
        font-weight: 500;
        font-size: 20px;
        color: #35383F;
    }
    .header-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
    .border-white {
        border-color: white !important;
    }
    .form-area {
        border-left: 1px solid #e0e3e7;
    }
    .v-stepper__step--complete .v-stepper__step__step.primary {
        background-color: #2FA84F !important;
    }
    .btn-containner {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .btn-group {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 160px;
    }
    .user-created-info {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: #35383F;
    }
</style>